import { LightbulbIcon } from "lucide-react";
import { Card } from "../ui/card";

const bgMap = {
  yellow: "bg-yellow-50 border-yellow-200",
  blue: "bg-blue-50 border-blue-200",
  green: "bg-green-50 border-green-200",
  red: "bg-red-50 border-red-200",
  purple: "bg-purple-50 border-purple-200"
};

const colorTextMap = {
  yellow: "text-yellow-800",
  blue: "text-blue-800",
  green: "text-green-800",
  red: "text-red-800",
  purple: "text-purple-800"
};

export function RecommendationBlock({
  heading = "Recommendations",
  icon = <LightbulbIcon className="h-5 w-5 text-orange-500" />,
  sections = []
}) {
  return (
    <Card className="p-4 shadow-sm bg-white">
      <div className="flex items-center gap-2 mb-4">
        {icon}
        <h3 className="text-base font-semibold text-gray-800">{heading}</h3>
      </div>

      {sections.map((section, idx) => {
        const color = section.color || "yellow";

        return (
          <div
            key={idx}
            className={`rounded-md p-4 mb-4 border ${bgMap[color]}`}
          >
            <h4 className={`font-semibold mb-2 ${colorTextMap[color]}`}>
              {section.title}
            </h4>

            <ul className={`list-disc pl-5 space-y-3`}>
              {Array.isArray(section.items) ? (
                section.items.map((item, i) => (
                  <li key={i} className="text-sm text-gray-800 space-y-1">
                    {typeof item === "string" ? (
                      item
                    ) : (
                      <>
                        {item.description && <p>{item.description}</p>}

                        {item.risk_implication && (
                          <p className="text-xs text-gray-600">
                            <strong>Risk:</strong> {item.risk_implication}
                          </p>
                        )}

                        {item.recommendation && (
                          <p className="text-xs text-gray-600">
                            <strong>Recommendation:</strong>{" "}
                            {item.recommendation}
                          </p>
                        )}

                        {item.potential_implications?.length > 0 && (
                          <p className="text-xs text-gray-600">
                            <strong>Implications:</strong>{" "}
                            {item.potential_implications.join(", ")}
                          </p>
                        )}
                      </>
                    )}
                  </li>
                ))
              ) : (
                <li className="text-sm italic text-gray-500">No valid items</li>
              )}
            </ul>
          </div>
        );
      })}
    </Card>
  );
}
